import gql from 'graphql-tag';
import { municipalityFragments } from './Municipality';

export const unitSettingFragments = gql`
  fragment unitSettingFragments on UnitSetting {
    id
    companyNameOption
    oldLogos {
      id
      url(size: SMALL)
    }
    logo {
      id
      signedBlobId
      fileName
      url(size: LARGE)
    }
    savedBy {
      id
      name
    }
    savedAt
  }
`;

export const unitInvoiceSettingFragments = gql`
  fragment unitInvoiceSettingFragments on UnitInvoiceSetting {
    id
    usesKid
    kidLength
    kidModDigit
    customerCreditDays
    startingOrderNumber
    startingInvoiceNumber
    invoiceEmailCopy
    exports
    productGroups
    taxInclusiveAmountRounding
    customerCountry {
      code
    }
    currencyCode
    legalNotes
    customNote
    bban
    iban
    swift
    displaySettings {
      invoiceLineCar
      invoiceLineDepartment
      invoiceLineProject
      invoiceLineOrderedQuantity
      invoiceLineTaxAmount
      invoiceLineAllowanceCharge
      invoiceAllowanceCharge
      invoiceCar
      invoiceProject
      invoiceDepartment
    }
    defaultProductUnitOfMeasureCode
    supplierPartyReferenceSetting
    paymentMethods
    usesOverdueNotices
    overdueNoticeCharge
    usesInterestInvoices
    efakturaEnabled
    orderSaveLockConfirmation
  }
`;

export const unitPaycheckSettingFragments = gql`
  fragment unitPaycheckSettingFragments on UnitPaycheckSetting {
    id
    startingPaycheckNumber
    altinn3AuthAs
    defaultVacationMoneyPercentage
    defaultCreditDays
    defaultWorkRelation {
      subUnitId
      occupationId
      employmentType
      durationType
      shiftType
      hoursEveryWeekWithFullEmployment
      employmentPercentage
    }
    currencyCode
    municipality {
      ...municipalityFragments
    }
  }
  ${municipalityFragments}
`;

export const UNIT_INVOICE_SETTINGS = gql`
  query unitInvoiceSetting {
    currentUnit {
      id
      name
      unofficialName
      address
      zip
      city
      highestPriorityIdentity {
        id
        value
        identificator {
          id
          name
        }
      }
      country {
        code
        name
      }
      phone
      mobile
      website
      email
      unitSetting {
        ...unitSettingFragments
        unitInvoiceSetting {
          ...unitInvoiceSettingFragments
        }
      }
      vatRegulation
    }
  },
  ${unitSettingFragments}
  ${unitInvoiceSettingFragments}
`;

export const UNIT_PAYCHECK_SETTINGS = gql`
  query unitPaycheckSetting {
    currentUnit {
      id
      name
      unofficialName
      address
      zip
      city
      highestPriorityIdentity {
        id
        value
        identificator {
          id
          name
        }
      }
      country {
        code
        name
      }
      phone
      mobile
      website
      email
      unitSetting {
        ...unitSettingFragments
        unitPaycheckSetting {
          ...unitPaycheckSettingFragments
        }
      }
    }
  },
  ${unitSettingFragments}
  ${unitPaycheckSettingFragments}
`;
